<template>
  <div>
    <CoinHeading :name="coinData.name" :symbol="coinData.symbol" :iconUrl="coinData.iconUrl" v-if="mode === 'Edit'" />
    <form v-on:submit.prevent>
      <div class="form-group" v-if="mode === 'Add'">
        <label class="form-label" for="form-name">Name</label>
        <input
          id="form-name"
          class="form-input"
          type="text"
          placeholder="e.g. Bitcoin"
          v-model="userInputs.name"
          @keyup="isFormValid">
      </div>
      <div class="form-group" v-if="mode === 'Add'">
        <label class="form-label" for="form-code">Symbol</label>
        <input
          id="form-code"
          class="form-input"
          type="text"
          placeholder="e.g. BTC"
          v-model="userInputs.code"
          @keyup="isFormValid">
      </div>
      <div class="form-group">
        <label class="form-label" for="form-amount">Amount</label>
        <input
          id="form-amount"
          class="form-input"
          type="number"
          min="0"
          step="0.00000000001"
          placeholder="e.g. 1000.01"
          v-model="userInputs.amount"
          @keyup="isFormValid">
      </div>
      <div class="form-group">
        <label class="form-label" for="form-purchase-currency">Purchase currency</label>
        <input
          id="form-purchase-currency"
          class="form-input"
          type="text"
          pattern=".{3,3}"
          placeholder="e.g. GBP"
          value="GBP"
          readonly>
      </div>
      <div class="form-group">
        <label class="form-label" for="form-purchase-price">Purchase Price</label>
        <input
          id="form-purchase-price"
          class="form-input"
          type="number"
          min="0"
          step="0.01"
          placeholder="e.g. 100.50"
          v-model="userInputs.purchasePrice"
          @keyup="isFormValid">
      </div>
      <div class="button-wrapper text-center">
        <button class="btn btn-primary" @click="addCoin" :disabled="!validForm" v-if="mode === 'Add'">
          <i class="fa fa-plus"></i> Add
        </button>
        <button class="btn btn-primary" @click="editCoin" :disabled="!validForm" v-if="mode === 'Edit'">
          <i class="fa fa-edit" ></i> Update
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Router from '@/router';
import Service from '@/service';
import CoinHeading from '@/components/coin/CoinHeading';

export default {
  name: 'CustomCoinForm',
  components: {
    CoinHeading,
  },
  data() {
    return {
      mode: 'Add',
      coinData: {},
      validForm: false,
      userInputs: {},
    };
  },
  mounted() {
    this.getExistingCoinData();
  },
  methods: {
    getExistingCoinData() {
      if (this.$route.name === 'Edit') {
        this.mode = this.$route.name;

        if (this.$route.params.purchaseId) {
          const coin = Service.getPurchaseByKey(this.$route.params.purchaseId);

          if (coin.id) {
            // if id exist, then this coin exists on the market already, fetch coin from API
            Service.getCoinsByIds(coin.id).then((response) => {
              if (response && response.status === 'success') {
                if (response.data && response.data.coins && response.data.coins.length === 1) {
                  const result = response.data.coins[0];

                  this.coinData = {
                    name: result.name,
                    symbol: coin.code,
                    iconUrl: result.iconUrl,
                  };

                  // then pre-populate fields
                  this.userInputs = {
                    id: coin.id,
                    key: coin.key,
                    name: result.name,
                    code: coin.code,
                    amount: coin.amount,
                    purchasePrice: coin.purchasePrice,
                  };

                  this.isFormValid();
                }
              }
            });
          } else {
            // if id doesn't exist, then pre-populate using user's input
            this.coinData = {
              name: coin.name,
              symbol: coin.code,
              iconUrl: false,
            };

            this.userInputs = {
              key: coin.key,
              name: coin.name,
              code: coin.code,
              amount: coin.amount,
              purchasePrice: coin.purchasePrice,
            };
            this.isFormValid();
          }
        }
      }
    },
    isFormValid() {
      const hasUserData = this.userInputs && this.userInputs.name && this.userInputs.code && this.userInputs.amount && this.userInputs.purchasePrice;
      if (hasUserData) {
        this.validForm = true;
      } else {
        this.validForm = false;
      }
    },
    addCoin() {
      if (this.validForm) {
        const coin = this.userInputs;
        coin.purchaseCurrency = 'GBP';

        Service.addPurchase(Object.assign({}, coin));
        Router.push({ name: 'Account' });
      }
    },
    editCoin() {
      if (this.validForm) {
        const coin = this.userInputs;
        coin.purchaseCurrency = 'GBP';

        Service.updatePurchase(coin);
        Router.push({ name: 'Account' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
form {
  padding: 1rem;

  .button-wrapper {
    text-align: center;

    button {
      padding: 0 1.5rem;
      margin-top: 0.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/CustomCoinForm.vue